<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId && (editMode || getOptionValue(StoryEntity))"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :use-example-data="editMode"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import LayoutCardSize from "%/dynamic-component-editor/options/layout-card-size";
import StoryEntity from "%/dynamic-component-editor/options/story-entity";
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";

// Default DC depends on the LayoutCardSize option: "small" → "Story Card",
// anything else → "Large Story Card". `defaultComponentName` is a
// computed (not a fixed data field) so the DcHostMixin re-resolves
// whenever the size toggle flips.
export default {
  name: "SingleStoryCard",
  components: { DynamicComponentProduction },
  mixins: [DynamicElementMixin, BaseStoryCardElementMixin, DcHostMixin],
  // Deliver the linked story id by inject (the embedded DC drops entity-id); the
  // card's child elements resolve it via pageEntities().story — mirrors SmartFeedItem.
  provide() {
    return {
      pageEntities: () => {
        const parent = typeof this.pageEntities === "function" ? this.pageEntities() : this.pageEntities ?? {};
        return { ...parent, story: this.getOptionValue(StoryEntity) };
      },
    };
  },
  relatedComponents: ["Story Card", "Large Story Card"],
  elementPanelSettings: {
    tags: ["story", "card", "post"],
    displayName: "Story Card",
    displayIcon: "prime:book",
    elementGroup: "general",
    elementType: "element",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-height": "hug",
      "default.layout-width": "hug",
    }),
  ],
  options: [
    ReferencedComponentId,
    ContextBindings,
    LayoutCardSize,
    StoryEntity,
  ],
  data() {
    return {
      StoryEntity,
    };
  },
  computed: {
    defaultComponentName() {
      const cardSize = this.getOptionValue(LayoutCardSize);
      return cardSize === "small" ? "Story Card" : "Large Story Card";
    },
  },
};
</script>
